const DEFAULT_INACTIVITY_TIMEOUT_MINUTES = 30;

const parsePositiveNumber = (value: string | undefined): number | null => {
  if (!value) {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }

  return parsed;
};

export const getInactivityTimeoutMs = (): number => {
  const configuredMinutes = parsePositiveNumber(process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES);
  const timeoutMinutes = configuredMinutes ?? DEFAULT_INACTIVITY_TIMEOUT_MINUTES;

  return timeoutMinutes * 60 * 1000;
};
